import langEn from './en.js'
import langZh from './zh.js'
import langCht from './cht.js'
import langKor from './kor.js'
import langVie from './vie.js'
import langId from './id.js'
import langJp from './jp.js'
import langTh from './th.js'
import langAra from './ara.js'
import Vue from 'vue'
import VueI18n from './vue-i18n'
Vue.use(VueI18n)

if (!uni.getStorageSync("lang")) {
	uni.setStorageSync("lang", "ara");
}
const i18n = new VueI18n({
	locale: uni.getStorageSync("lang"),
	messages: {  
			'zh': langZh,
			'en': langEn,
			'cht': langCht,
			'kor': langKor,
			'vie': langVie,
			'id': langId,
			'jp': langJp,
			'th': langTh,
			'ara': langAra,
		}
})
export default i18n